import { createConnector, normalizeChainId } from '@wagmi/core';
import { W3mFrameProvider } from '@web3modal/wallet';
import { SwitchChainError, getAddress } from 'viem';
import { ConstantsUtil } from '@web3modal/scaffold-utils';
export function emailConnector(parameters) {
    return createConnector(config => ({
        id: ConstantsUtil.EMAIL_CONNECTOR_ID,
        name: 'Web3Modal Email',
        type: 'w3mEmail',
        async connect(options = {}) {
            const provider = await this.getProvider();
            const { address, chainId } = await provider.connect({ chainId: options.chainId });
            const { isDeployed, address: smartAccountAddress } = await this.initSmartAccount();
            if (isDeployed && smartAccountAddress) {
                return {
                    accounts: [smartAccountAddress],
                    account: smartAccountAddress,
                    chainId,
                    chain: {
                        id: chainId,
                        unsuported: false
                    }
                };
            }
            return {
                accounts: [address],
                account: address,
                chainId,
                chain: {
                    id: chainId,
                    unsuported: false
                }
            };
        },
        async initSmartAccount() {
            if (!parameters.options.enableSmartAccounts) {
                return { isDeployed: false };
            }
            const provider = await this.getProvider();
            const chainId = await this.getChainId();
            const { smartAccountEnabledNetworks } = await provider.getSmartAccountEnabledNetworks();
            if (smartAccountEnabledNetworks.includes(chainId)) {
                return (await provider.initSmartAccount());
            }
            return { isDeployed: false };
        },
        async disconnect() {
            const provider = await this.getProvider();
            await provider.disconnect();
        },
        async getAccounts() {
            const provider = await this.getProvider();
            const { address } = await provider.connect();
            return [address];
        },
        async getProvider() {
            if (!this.provider) {
                this.provider = new W3mFrameProvider(parameters.options.projectId);
            }
            return Promise.resolve(this.provider);
        },
        async getChainId() {
            const provider = await this.getProvider();
            const { chainId } = await provider.getChainId();
            return chainId;
        },
        async isAuthorized() {
            const provider = await this.getProvider();
            const { isConnected } = await provider.isConnected();
            return isConnected;
        },
        async switchChain({ chainId }) {
            try {
                const chain = config.chains.find(c => c.id === chainId);
                if (!chain) {
                    throw new SwitchChainError(new Error('chain not found on connector.'));
                }
                const provider = await this.getProvider();
                await provider.switchNetwork(chainId);
                config.emitter.emit('change', { chainId: normalizeChainId(chainId) });
                return chain;
            }
            catch (error) {
                if (error instanceof Error) {
                    throw new SwitchChainError(error);
                }
                throw error;
            }
        },
        onAccountsChanged(accounts) {
            if (accounts.length === 0) {
                this.onDisconnect();
            }
            else {
                config.emitter.emit('change', { accounts: accounts.map(getAddress) });
            }
        },
        onChainChanged(chain) {
            const chainId = normalizeChainId(chain);
            config.emitter.emit('change', { chainId });
        },
        async onConnect(connectInfo) {
            const chainId = normalizeChainId(connectInfo.chainId);
            const accounts = await this.getAccounts();
            config.emitter.emit('connect', { accounts, chainId });
        },
        async onDisconnect(_error) {
            const provider = await this.getProvider();
            await provider.disconnect();
        }
    }));
}
//# sourceMappingURL=EmailConnector.js.map